<template>
    <div class="block-box">
        <div class="block-item">
            <div class="label">
                {{configData.title}}
            </div>
            <el-switch v-model="configData.val"></el-switch>
        </div>
    </div>
</template>

<script>
    export default {
        name: "editorswitch",
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
    }
</script>

<style scoped>

</style>
